import styled, { css } from "styled-components";
import { simpleHeaderDesktopHeightSpace, pageGutterSpace, zIndex } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import { sizesSpace } from "../../organisms/ContainerOrg";
import { bottomBarOrgBackgroundStyles } from "../../organisms/PageHeaderOrg/components/BottomBarOrg/BottomBarOrg.styled";
import Link from "../../quarks/Link";
import Picture from "../../quarks/Picture";
var minimalGutterSpace = 6;
var additionalClickableSpace = 1;
var horizontalPadding = "calc((100% - ".concat(space(sizesSpace["default"]), ") / 2 - ").concat(space(pageGutterSpace), " + ").concat(space(2), ")");
export var StyledSimplePageHeaderMol = styled.div.withConfig({
  componentId: "sc-uy24tm-0"
})(["position:sticky;top:0;z-index:", ";"], zIndex.PageHeaderOrgMain);
export var Container = styled.header.withConfig({
  componentId: "sc-uy24tm-1"
})(function (_ref) {
  var $backgroundColor = _ref.$backgroundColor,
    $hasChildren = _ref.$hasChildren,
    theme = _ref.theme;
  return css(["display:flex;flex-wrap:wrap;gap:", " ", ";position:relative;z-index:", ";align-items:center;padding:", ";background:", ";box-shadow:", ";", "{height:", ";padding:0 ", ";}", "{padding:0 ", ";}", ""], space(1.5), space(minimalGutterSpace), zIndex.PageHeaderOrgMain, space(2), getColor(theme, $backgroundColor), getBoxShadow(theme, "tiny"), breakpoint("medium"), space(simpleHeaderDesktopHeightSpace), space(2), breakpoint("huge"), horizontalPadding, $hasChildren && css(["justify-content:space-between;"]));
});
export var StyledLink = styled(Link).withConfig({
  componentId: "sc-uy24tm-2"
})(["position:relative;&::after{content:\"\";position:absolute;top:", ";right:", ";bottom:", ";left:", ";}"], space(-1 * additionalClickableSpace), space(-1 * additionalClickableSpace), space(-1 * additionalClickableSpace), space(-1 * additionalClickableSpace));
export var StyledImage = styled(Picture).withConfig({
  componentId: "sc-uy24tm-3"
})(["", "{max-height:", ";}"], breakpoint("small", "medium"), space(2.5));
export var MobileItems = styled.div.withConfig({
  componentId: "sc-uy24tm-4"
})(["width:100%;", "{display:none;}"], breakpoint("medium"));
export var SimplePageHeaderBottomBar = styled.div.withConfig({
  componentId: "sc-uy24tm-5"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["padding:", " ", ";", " ", "{padding:", " ", ";}"], space(1.5), space(2), bottomBarOrgBackgroundStyles(theme), breakpoint("huge"), space(1.5), horizontalPadding);
});